<template>
<div class="container">
    <PauseModal v-if="modal_pause" @restart="
        modal_pause = !modal_pause;
        reset=true;
        play=true;
        playMusic = !playMusic;
      " @closeModal="
        modal_pause = !modal_pause;
        reset=true;
        finish_play();
        ct=3;
      " @resume="
        modal_pause = !modal_pause;
        reset=false;
        play=true;
        playMusic = !playMusic;
      " />
    <Congratulations v-if="congrats_modal" gallery @restart="congrats_modal = !congrats_modal;" @backToMenu="$emit('backToMenu');" @saveGame="$emit('onSavingGame', steps); congrats_modal = !congrats_modal;" />

    <div v-show="onCount" id="dancing-counting" class="dancing-counting">
        <h1 id="dancing-count-number" class="dancing-count-number"> 3 </h1>
    </div>

    <div id="dancing-container" class="container-2">
        <div class="score-container-dancing">
            <PhraseDisplay :disable="true" :playing="play" :phrase="steps" :alternatives="alternatives" :levels="curve" @changed_step="change_step" />
        </div>
        <div id="score-container-dancing-canvas" class="score-container-dancing-canvas">
            <canvas :id="'canvas-score'" class="canvas"></canvas>
        </div>
        <div id="dancing-playing-bar" class="playing-line" :class="{'active': active}"></div>
    </div>
    <MidiPlayer :midi="midi" :playMidi="playMusic" :velocity="velocity" @finishedPlaying="finish_play" :reset="reset" @currentPosition="viewPosition"></MidiPlayer>

    <div>
        <div class="complete-melody tamanhoicon" @click="finish">
            <img :src="require('@/assets/buttons/newbuttons/dance/submit.svg')" />
        </div>

        <div>
            <img id="speedbarcaracol-sum-d" :src="require('@/assets/buttons/newbuttons/speedbar/caracoldanca.svg')" />
            <img id="speedbarcoelho-sum-d" :src="require('@/assets/buttons/newbuttons/speedbar/coelhodanca.svg')" />
        </div>
        <div id="speedbar_play" class="tamanhoicon speed-bar-sum-d">

            <input type="range" min="0.25" max="2.0" step="0.25" list="tickmarks" v-model="velocity" class="slider" id="Speed-Range-Dance">
            <datalist id="tickmarks">
                <option value="0.25"></option>
                <option value="0.5" label="0.5"></option>
                <option value="0.75"></option>
                <option value="1.0" label="1"></option>
                <option value="1.25"></option>
                <option value="1.5" label="1.5"></option>
                <option value="1.75"></option>
                <option value="2.0" label="2"></option>
            </datalist>
        </div>

        <div id="menu_play" class="tamanhoicon">
            <img @click="play_pause" :src="require('@/assets/buttons/newbuttons/dance/pause.svg')" v-if="play" />
            <img @click="play_pause" :src="require('@/assets/buttons/newbuttons/dance/play.svg')" v-else />
        </div>
        <div>
            <div @click="back_phrase('slow')" id="back" class="tamanhoicon" :disabled="back_arrow_disabled">
                <img :src="require('@/assets/buttons/newbuttons/dance/seta_esq.svg')" />
            </div>
            <div @click="next_phrase('slow')" id="forward" class="tamanhoicon" :disabled="next_arrow_disabled">
                <img :src="require('@/assets/buttons/newbuttons/dance/seta_drt.svg')" />
            </div>
        </div>

    </div>
</div>
</template>

<script>
import MidiPlayer from "../General/MidiPlayer.vue";
import PhraseDisplay from "@/components/DancingGame/PhraseDisplay.vue";
import PauseModal from "@/components/DancingGame/PauseModal.vue";
import Congratulations from "@/components/DancingGame/Congratulations.vue";

export default {
    name: "Score",
    emits: ['backToMenu', 'restart', 'onSavingGame'],
    components: {
        MidiPlayer,
        PhraseDisplay,
        PauseModal,
        Congratulations,
    },
    created() {
        window.addEventListener("resize", this.resize);
    },
    mounted() {
        this.resize();
    },
    data() {
        return {
            play: false,
            playMusic: false,
            midi: "",
            reset: false,
            active: false,

            currentScroll: 0,
            muted: false,
            velocity: 1.0,

            modal_pause: false,
            congrats_modal: false,
            alert_modal: false,

            onCount: false,
            counter: false,
            ct: 3,

            next_arrow_disabled: false,
            back_arrow_disabled: true,

            beat_positions: {},

            curve: [],
            beats: [],
            steps: [],
            coord: []
        };
    },
    props: {
        phrases: Object,
    },
    methods: {
        finish() {
            this.congrats_modal = true;
            this.play = false;
            this.playMusic = false;
        },
        change_step(opt) {
            let or_steps = Object.values(this.phrases.proposed_dance);
            let or_step_pos = or_steps[opt[0]];
            for (let i = opt[0]; i < or_steps.length; i++) {
                if (or_steps[i].name === or_step_pos.name) {
                    this.steps[i] = opt[1];
                } else {
                    break;
                }
            }
        },
        resize() {
            this.calculateCurves();
            this.drawPhrase();
        },
        calculateCurves() {
            let beats = Object.values(this.phrases.music);
            this.curve = beats.map((e) => {
                if (e['notes'][0][3] != 0) return e['notes'][0][3];
                let poss = e['notes'].map((e1) => {
                    return e1[3]
                });
                let non_zero = poss.find((value) => value !== 0);
                if (non_zero !== undefined) return non_zero;
                return 2;
            });
            this.beats = beats;
            this.steps = Object.values(this.phrases.proposed_dance);
            this.alternatives = this.phrases.all_possible_steps;
            this.coord = this.calculateCurveFromPoints(this.curve);
        },
        calculateCurveFromPoints(points) {
            let width = window.innerWidth * ((points.length + 1) / 5.5);
            let height = window.innerHeight;

            let div_w = width / (points.length + 1);
            let div_h = height / 8;

            let line_3 = [];

            line_3.push({
                x: 0,
                y: height / 2.0,
            });

            let last_x = 0;
            for (let j = 0; j < points.length; j++) {
                last_x += div_w;

                let num = points[j];
                let y = num * div_h;
                if (num == 1) {
                    y -= div_h / 6.0;
                }
                if (num == 3) {
                    y += div_h / 6.0;
                }

                line_3.push({
                    x: last_x,
                    y: y,
                });
            }

            line_3.push({
                x: last_x + div_w,
                y: height / 2.0,
            });

            let maxArray = Math.max.apply(null, line_3.map(function (el) {
                return el.y + 2.5 * div_h
            }));
            let minArray = Math.min.apply(null, line_3.map(function (el) {
                return el.y - 0.5 * div_h
            }));
            if (maxArray > window.innerHeight) {
                line_3 = line_3.map(function (el) {
                    return {
                        x: el.x,
                        y: el.y - (window.innerHeight - maxArray) - 5
                    }
                });
            } else if (minArray < window.innerHeight / 9.0) {
                line_3 = line_3.map(function (el) {
                    return {
                        x: el.x,
                        y: el.y + (window.innerHeight / 9.0)
                    }
                });
            }
            return {
                line_1: line_3.map(function (el) {
                    return {
                        x: el.x,
                        y: el.y + div_h,
                    };
                }),
            };
        },
        drawPhrase() {
            let canvas = document.getElementById("canvas-score");
            let cv_rect = canvas.getBoundingClientRect();

            let ctx = canvas.getContext("2d");

            cv_rect.width = this.coord['line_1'][this.coord['line_1'].length - 1].x;
            ctx.canvas.width = this.coord['line_1'][this.coord['line_1'].length - 1].x;
            canvas.width = this.coord['line_1'][this.coord['line_1'].length - 1].x;
            canvas.height = cv_rect.height;

            ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
            for (let line in this.coord) {
                this.draw_curve_aux(ctx, this.coord[line], 0.9, '#C4C8DC', 2);
            }
            setTimeout(() => {
                this.adjust_positions('line_1');
            })
        },
        adjust_positions(line) {
            let coord = this.coord[line].slice(1, this.coord[line].length - 1);

            // Beats
            for (let j = 0; j < coord.length; j++) {

                let cd = coord[j];

                let div = document.getElementById("Beat-" + j.toString());

                this.beat_positions["Beat-" + j.toString()] = [cd.x - (div.clientWidth / 4.0) + 'px', (2 / 3) * cd.y + 'px'];

                if (div != null) {
                    div.style.position = "absolute";
                    div.style.left = cd.x - (div.clientWidth / 4.0) + 'px';
                    div.style.top = (2 / 3) * cd.y + 'px';
                    //div.style.width = div.offsetWidth;
                }
            }

        },
        timer() {
            if (this.ct > 0) {
                let number = document.getElementById("dancing-count-number");
                number.innerHTML = this.ct;
                this.ct = this.ct - 1;
            } else {
                clearInterval(this.counter);
                this.onCount = false;
                this.play_music();
            }
        },
        startCount() {
            this.ct = 3;
            this.onCount = true;
            this.counter = setInterval(this.timer, 1000);
        },
        play_pause() {
            if (this.play) {
                this.popup_pausa();
            } else {
                this.ct = 3;
                this.onCount = true;
                this.counter = setInterval(this.timer, 1000);
            }
        },
        popup_pausa() {
            this.modal_pause = !this.modal_pause;
            this.play = false;
            this.playMusic = !this.playMusic;
        },
        finish_play() {
            this.play = false;
            this.removeLastBeatPlaying();
            let container = document.getElementById("dancing-container");
            container.scrollTo(0, 0);
            this.active = false;
            this.ct = 3;
        },
        removeLastBeatPlaying() {
            let beat_divs = document.getElementsByClassName('dance-step');
            let real_beat_divs = Array.from(beat_divs).filter((e) => {
                return e.style.display != 'none';
            });

            for (let div_i in real_beat_divs) {
                let div = real_beat_divs[div_i];
                if (div != undefined) {
                    div.classList.remove("playing-step");
                    div.classList.remove("next-playing-step");
                    if (div.parentNode != undefined) {
                        div.parentNode.removeAttribute('style');

                        div.parentNode.classList.remove("playing-step");
                        div.parentNode.classList.remove("next-playing-step");

                        div.parentNode.setAttribute('style', {});

                        div.parentNode.style.position = 'absolute';
                        div.parentNode.style.left = this.beat_positions[div.parentNode.id][0];
                        div.parentNode.style.top = this.beat_positions[div.parentNode.id][1];
                    }
                }
            }
        },
        viewPosition(pos) {

            let canvas = document.getElementById("canvas-score");
            let container = document.getElementById("dancing-container");
            let temp_scroll = 0;

            let beat_divs = document.getElementsByClassName('dance-step');
            let real_beat_divs = Array.from(beat_divs).filter((e) => {
                return e.style.display != 'none';
            })
            let pos_x_beat_divs = real_beat_divs.map((e) => {
                e.classList.remove("playing-step");
                e.classList.remove("next-playing-step");
                e.parentNode.classList.remove("playing-step");
                e.parentNode.classList.remove("next-playing-step");

                e.setAttribute('speed', 0);

                e.parentNode.style.position = 'absolute';
                e.parentNode.style.left = this.beat_positions[e.parentNode.id][0];
                e.parentNode.style.top = this.beat_positions[e.parentNode.id][1];

                return [e, e.getBoundingClientRect().left + container.scrollLeft];
            });

            if (pos !== 'Not Playing') {
                this.active = true;

                let div = document.getElementById('dancing-playing-bar');
                let canvas_width = canvas.width;

                if (container != null) {

                    let posX = pos * canvas_width;

                    let current_dance_step = this.get_nearest_step(posX, pos_x_beat_divs); // ver porque há um beat que não está a ser apanhado aqui!

                    current_dance_step[0][0].classList.add("playing-step");
                    current_dance_step[0][0].parentNode.classList.add("playing-step");

                    current_dance_step[0][0].setAttribute('speed', 1);

                    current_dance_step[0][0].parentNode.removeAttribute('style');
                    current_dance_step[0][0].parentNode.style.position = 'fixed';
                    current_dance_step[0][0].parentNode.parentNode.display = 'flex';
                    current_dance_step[0][0].parentNode.parentNode.style['justify-content'] = 'center';
                    current_dance_step[0][0].parentNode.style.top = '6%';

                    if (current_dance_step.length > 1) {
                        current_dance_step[1][0].classList.add("next-playing-step");
                        current_dance_step[1][0].parentNode.classList.add("next-playing-step");

                        current_dance_step[1][0].parentNode.removeAttribute('style');
                        current_dance_step[1][0].parentNode.style.position = 'fixed';
                        current_dance_step[1][0].parentNode.parentNode.display = 'flex';
                        current_dance_step[1][0].parentNode.style.right = '6%';
                    }
                    div.style.position = "absolute";
                    div.style.left = posX + 'px';

                    let max_scroll = Math.ceil(canvas_width / window.innerWidth);
                    for (let sX = 0; sX < max_scroll; sX++) {
                        if (posX > sX * window.innerWidth && posX < (sX + 1) * window.innerWidth) {
                            temp_scroll = sX * window.innerWidth;
                            break;
                        }
                    }
                }

            } else {
                this.active = false;
                temp_scroll = 0;
            }

            if (this.currentScroll !== temp_scroll) {
                container.scrollTo(temp_scroll, 0);
                this.currentScroll = temp_scroll;
            }
        },
        back_phrase(mode = 'slow') {
            let canvas = document.getElementById("canvas-score");
            let container = document.getElementById("dancing-container");

            if (mode === 'fast') {
                let width = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
                let num_phrases = Math.ceil(canvas.width / width);
                for (let i = 0; i < num_phrases; i++) {
                    if ((container.scrollLeft >= i * width && i > 0) && container.scrollLeft <= (i + 1) * width) {
                        container.scrollTo((i - 1) * width, 0);
                        break;
                    }
                }
            } else {
                if (container.scrollLeft > 0) {
                    container.scrollTo(container.scrollLeft - canvas.width / 10.0, 0);
                }
            }
            this.enable_buttons(container, canvas);
        },
        next_phrase(mode = 'slow') {
            let canvas = document.getElementById("canvas-score");
            let container = document.getElementById("dancing-container");

            if (mode === 'fast') {
                let width = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
                let num_phrases = Math.ceil(canvas.width / width);
                for (let i = 0; i < num_phrases; i++) {
                    if (container.scrollLeft >= i * width && container.scrollLeft < (i + 1) * width) {
                        container.scrollTo((i + 1) * width, 0);
                        break;
                    }
                }

            } else {
                if (container.scrollLeft < canvas.width - window.innerWidth) {
                    container.scrollTo(container.scrollLeft + canvas.width / 10.0, 0);
                }
            }
            this.enable_buttons(container, canvas);
        },
        enable_buttons(container, canvas) {
            if (container.scrollLeft > 0) {
                this.back_arrow_disabled = false;
            } else {
                this.back_arrow_disabled = true;
            }
            if (container.scrollLeft >= canvas.width - window.innerWidth) {
                this.next_arrow_disabled = true;
            } else {
                this.next_arrow_disabled = false;
            }
        },
        play_music() {

            let phrase = this.phrases.music;
            let notes = [];
            for (let b in Object.keys(phrase)) {
                let beat = Object.keys(phrase)[b];
                for (let note in phrase[beat]['notes']) {
                    let dur = phrase[beat]['notes'][note][2];
                    if (dur == 1) {
                        dur = this.phrases["whole_duration"];
                    }
                    notes.push([phrase[beat]['notes'][note][1], dur]);
                }
            }

            this.midi = {
                'tracks': {
                    '0': {
                        'instrument': this.$data.instruments.harmonic.Piano,
                        'is_percussion': false,
                        'notes': notes,
                        'is_muted': this.muted,
                        'loudness': 0.8
                    }
                },
                'whole_duration': this.phrases['whole_duration'],
            }

            let container = document.getElementById("dancing-container");
            this.currentScroll = container.scrollLeft;

            this.play = true;
            this.playMusic = !this.playMusic;
        }
    },
};
</script>

<style>
.container {
    width: 100%;
    height: 100%;

    position: absolute;
}

.complete {
    position: absolute;
    right: 1rem;
    bottom: 1rem;
}

.edit {
    position: absolute;
    left: 5rem;
    top: 1rem;
}

.play-dance {
    position: absolute;
    bottom: 1em;
    left: 50%;
}

.score-container {
    display: flex;
    align-self: center;
    flex-wrap: nowrap;
    align-items: center;
    align-content: center;
    justify-content: space-around;

    width: 100%;

    padding-top: 4%;
    height: 90%;
}

.lateral {
    width: 5%;
}

.rightbutton {
    margin-right: 3%;
}

.leftbutton {
    margin-left: 3%;
}

#back[disabled=true] {
    opacity: 0.7;
}

#forward[disabled=true] {
    opacity: 0.7;
}

.score {
    width: 80%;
    height: 100%;

    display: flex;
    align-self: center;
    flex-wrap: wrap;
    align-items: center;
    align-content: center;
    justify-content: space-around;

    /* display: inline_3-grid;
  grid-template-columns: 12.5% 12.5% 12.5% 12.5% 12.5% 12.5% 12.5% 12.5%;
  grid-template-rows: 33% 33% 33%; */
}

.beat-score {
    display: flex;
    align-self: center;
    justify-content: center;
}

.note {
    margin: 0 -1.2rem;
}

.beat-level-1 {
    margin-top: -45%;
}

.beat-level-2 {
    margin-top: -4em;
}

.beat-level-3 {
    margin-top: 35%;
}

.canvas {
    position: absolute;
    top: 0;

    width: 100%;
    height: 100%;

    z-index: -1;
}

.choose {
    background-color: rgba(255, 255, 255, 0.8);
    border-radius: 1em;
    height: 150%;
    padding: 1em;
}

.dancing-counting {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    background-color: rgba(178, 57, 8, 0.5);

    display: flex;
    justify-content: center;
    align-items: center;

    z-index: 10;
}

.dancing-count-number {
    font-size: 10rem;
    font-family: Omnes;
    font-weight: bold;
    color: white;
}

.speed-bar-sum-d {
    width: 15%;
    position: absolute;
    right: 7%;
    top: 13% !important;
}

#speedbarcoelho-sum-d {
    position: fixed;
    right: 4%;
    top: 18%;
    height: 5%;
    float: right;
    animation: moveSpeedIcons 1s ease-in-out;
}

#speedbarcaracol-sum-d {
    position: fixed;
    right: 22%;
    top: 18%;
    height: 5%;
    float: right;
    animation: moveSpeedIcons 1s ease-in-out;
}

@keyframes moveSpeedIcons {
    0% {
        margin-top: -45%;
    }

    100% {
        margin-top: 0;
    }
}

input[type=range] {
    -webkit-appearance: none;
}

#Speed-Range-Dance {
    height: 5px;
    border-radius: 5px;
    margin-top: 7%;
    outline: none;
    filter: drop-shadow(0px 4px 2px rgba(0, 0, 0, 0.25));
    stroke: none;
    background: #BD0D0F;
}

#Speed-Range-Dance::-webkit-slider-thumb {
    -webkit-appearance: none;
    border: none;
    height: 15px;
    width: 15px;
    border-radius: 50%;
    background: #ffffff;
    margin-top: -13px;
}

#Speed-Range-Dance[type=range]::-ms-fill-upper {
    background: #ddd;
    border-radius: 10px;
}

#Speed-Range-Dance::before {
    -webkit-appearance: none;
    opacity: 0%;
}

@media only screen and (max-width: 686px) {
    .lateral {
        width: 2.7rem;
        height: 2.7rem;
    }

    .rightbutton {
        margin-right: 3%;
    }

    .edit {
        left: 4.5rem;
    }

    .note {
        margin: 0 -1rem;
        width: 4rem;
    }

    .choose {
        padding: 0.8rem;
    }

    .beat-level-2 {
        margin-top: -1em;
    }

    .beat-level-3 {
        margin-top: 37%;
    }

    .hidden {
        height: 5em;
        width: 2em;
        opacity: 0;
    }

    .score {
        width: 78%;
    }

    .dancing-count-number {
        font-size: 10rem;
    }

}

@media only screen and (min-width: 1024px) {

    .lateral {
        width: 4.5rem;
        height: 4.5rem;
    }

    .edit {
        left: 6.5rem;
    }

    .note {
        margin: 0 -1.5rem;
        width: 7rem;
    }

    .score {
        width: 79%;
    }

    .dancing-count-number {
        font-size: 30rem;
    }
}

@media only screen and (min-width: 1300px) {

    .lateral {
        width: 6rem;
        height: 6rem;
    }

    .edit {
        left: 7.5rem;
    }

    .note {
        margin: 0 -1.5rem;
        width: 9rem;
    }

    .hidden {
        height: 11.3em;
        width: 6em;
    }

    .dancing-count-number {
        font-size: 50rem;
    }

}
</style>
